import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
let router = new Router({
  linkExactActiveClass: 'exact',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue')
    },
    {
      /**1.物料基础数据 */
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.home.vue')
    }
  ]
});

export default router;
